import React from "react";
import { Flex } from "@chakra-ui/react";
import { HeaderWrapper } from "ui";
import BuyHbar from "./BuyHbar";

interface HeaderProps {
  walletComponent?: React.ReactNode;
  subHeaderItems: any;
}

export const Header = ({ walletComponent, subHeaderItems }: HeaderProps) => {
  const headerBody = (
    <Flex justifyContent="flex-end" gap="1rem">
      {walletComponent}
      <BuyHbar></BuyHbar>
    </Flex>
  );

  return (
    <HeaderWrapper subHeaderItems={subHeaderItems}>{headerBody}</HeaderWrapper>
  );
};
